// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1F8CN","errorLogs":"styles_errorLogs__3ti5H"};